import {
  getArticleByIdTypes,
  getArticleBySlugTypes,
  getArticleListTypes,
  getArticlesTypes,
  setCurrentPage,
  getArticleCoverImagesTypes,
  getTaxonomyArticlesTypes,
} from './types';
import { getLandingPageTypes } from '../landingPages/types';

const initState = {
  isLoading: false,
};

const articleReducer = (state = initState, action) => {
  const { type, payload } = action;

  switch (type) {
    case setCurrentPage.REQUEST: {
      return { ...state, currentPage: payload };
    }

    case getArticlesTypes.REQUEST:
    case getTaxonomyArticlesTypes.REQUEST:
    case getArticleListTypes.REQUEST:
    case getArticleByIdTypes.REQUEST: {
      return { ...state, error: null, isLoading: true };
    }

    case getArticleBySlugTypes.REQUEST: {
      return { ...state, article: {}, error: null, isLoading: true };
    }

    case getArticleBySlugTypes.DISMOUNT: {
      return { ...state, error: null, article: {} };
    }

    case getArticleListTypes.FAILED:
    case getArticleBySlugTypes.FAILED:
    case getArticleByIdTypes.FAILED:
      return { ...state, error: payload, isLoading: false };

    case getTaxonomyArticlesTypes.FAILURE:
    case getArticlesTypes.FAILED: {
      return { ...state, error: payload, isLoading: false, articles: [] };
    }

    case getArticleBySlugTypes.SUCCESS:
    case getArticleByIdTypes.SUCCESS: {
      return { ...state, isLoading: false, article: payload, showAd: true };
    }

    case getArticlesTypes.SUCCESS:
    case getTaxonomyArticlesTypes.SUCCESS:
    case getArticleListTypes.SUCCESS: {
      return { ...state, isLoading: false, ...payload };
    }

    case getLandingPageTypes.SUCCESS: {
      return { ...state, articles: null };
    }

    case getArticleCoverImagesTypes.REQUEST: {
      return { ...state, error: null, isLoadingCoverImages: true, coverImages: null };
    }

    case getArticleCoverImagesTypes.SUCCESS: {
      const { coverImages, page } = payload;
      return {
        ...state,
        error: null,
        isLoadingCoverImages: false,
        coverImagesPage: page,
        coverImages,
      };
    }

    case getArticleCoverImagesTypes.FAILED: {
      return {
        ...state,
        error: payload,
        isLoadingCoverImages: false,
        coverImagesPage: 1,
        coverImages: null,
      };
    }

    case getArticleCoverImagesTypes.CLEAR: {
      return {
        ...state,
        error: null,
        isLoadingCoverImages: false,
        coverImagesPage: 1,
        coverImages: null,
      };
    }

    default:
      return state;
  }
};

export default articleReducer;
